import { addMonths, eachMonthOfInterval, format, subMonths } from 'date-fns';
import { flatten, groupBy, mapObjIndexed, mergeAll, omit, prop, values } from 'ramda';

import { MAX_VISIBLE_DEBTS } from '../components/shared/constants';
import { Debt } from '../models/debt';

// date formats for use with date-fns
export const dateFormats = {
  day: 'd',
  dayLeadingZero: 'dd',
  firebaseCreationTime: "EEE, dd MMM yyyy HH:mm:ss 'GMT'",
  longMonth: 'MMMM',
  monthDayYear: 'MM/dd/yyyy',
  shortMonthYear: 'MMM yyyy',
  longMonthYear: 'MMMM yyyy',
  yearMonthDay: 'yyyy-MM-dd',
  yearMonth: 'yyyy-MM',
  year: 'yyyy',
};

export const getDebtIdFromPathname = (pathName: string) => {
  const split = pathName.split('/');
  return split.pop() || split.pop(); // handle potential trailing slash
};

export const getHistoryFromDebts = (debts: Debt[], isMobile: boolean | undefined) => {
  // TODO: Obviously must be a better way to do this... Probably use Dynamic properties (ex. const x = { ['a' + '_' + 'b']: 'z' } )
  // start -> [{name: "Chase", data: [{ month: "July", balance: 2424 }]}, {name: "UpStart", data: [{...
  // end goal -> [{ name: "July", Chase: 2423, UpStart: 1342.32}, { name: "August", ...}
  const groupedByNameOfDebt = groupBy(prop('name'))(debts);
  const mappedWithDebt = mapObjIndexed((val: any, debt) => {
    const history = val[0].history;
    if (history) {
      return history.map((hist: any) => {
        hist = { ...hist, [debt]: hist.balance };
        return omit(['balance'])(hist);
      });
    } else {
      return [];
    }
  })(groupedByNameOfDebt);
  const flattenedArrays = flatten(values(mappedWithDebt));
  const groupedByMonth = groupBy(prop('month'), flattenedArrays);
  const mergedAll = mapObjIndexed((val: any[]) => mergeAll(val))(groupedByMonth);

  const finalHistory = values(mergedAll);
  if (debts.length > MAX_VISIBLE_DEBTS && isMobile) {
    return finalHistory.map((val: any) => {
      const numberArr: number[] = values(val).filter(
        (anotherVal) => typeof anotherVal === 'number'
      );
      const sum = numberArr.reduce((a, b) => a + b);
      const average = sum / numberArr.length;
      return { month: val.month, Average: +average.toFixed(2) };
    });
  }
  return finalHistory;
};

export const getMonths = () => {
  return eachMonthOfInterval({
    start: subMonths(new Date(), 4),
    end: addMonths(new Date(), 1),
  })
    .reverse()
    .map((m) => ({
      label: format(m, dateFormats.longMonthYear),
      value: format(m, dateFormats.yearMonth),
    }));
};
